import { create } from "zustand"
import axios from "@/utils/axios"
import useCommonStore from "./commonStore"
import { syncUserCart } from "@/lib/cart"

interface IObj {
    [key: string]: any
}

export interface ICartItem {
    pdt_id: string
    variant_id: string
    quantity: number
}

type States = {
    cart: ICartItem[]
}

interface IResponse { status: boolean; data?: any; message?: string; error?: string }

type Actions = {
    cartDetails: (items?: ICartItem[]) => Promise<IResponse>
    setCart: (items: ICartItem[], isAuth?: boolean) => void
    updateCart: (item: ICartItem, mxq?: number, isAuth?: boolean) => Promise<IResponse>
    updateUserCart: (doc: { items: ICartItem[] }) => Promise<IResponse>
}


function parseCart(cartString: string): ICartItem[] {
    try {
        return JSON.parse(cartString);
    } catch {
        return [];
    }
}


const useCartStore = create<States & Actions>((set, get) => ({
    cart: typeof window !== "undefined" && localStorage.getItem("cart") ? parseCart(localStorage.getItem("cart") || "[]") : [],
    setCart: (items: ICartItem[], isAuth: boolean = false) => {
        set({ cart: items });
        if (typeof window !== "undefined") {
            if (isAuth) localStorage.removeItem("cart");
            else localStorage.setItem("cart", JSON.stringify(items));
        }
    },
    cartDetails: async (items?: ICartItem[]) => {
        try {
            const result = await axios.post(process.env.NEXT_PUBLIC_BOOKING_SERVICE + "/cart/details", { items: items || get().cart });
            if (result?.data?.status) {
                return { status: true, data: result.data?.data };
            } else {
                return { status: false, error: result.data?.error || "Something went wrong" };
            }
        } catch (error: any) {
            return { status: false, error: error?.message || "Something went wrong" };
        }
    },
    updateUserCart:async(doc:{items:ICartItem[]})=>{
        let update =  await syncUserCart(doc)
        if(update.status){
            get().setCart(update.data.cart, true)
        }
        return update
    },
    updateCart: async (item: ICartItem, mxq: number = -1, isAuth?: boolean) => {
        const { pdt_id, variant_id, quantity } = item;
        if (!pdt_id) return { status: false, message: "Please select a product" };
        if (isAuth) {
            return get().updateUserCart({ items: [{ ...item, quantity: quantity < 0 ? 0 : quantity }] })
        } else {
            const cartItems = [...get().cart];
            const index = cartItems.findIndex(i => i.pdt_id === pdt_id && i.variant_id === variant_id);
            if (index !== -1) {
                if (mxq >= 0 && (quantity > mxq)) {
                    cartItems[index].quantity = mxq;
                    get().setCart(cartItems);
                    return { status: false, message: "Maximum quantity exceeded", error: `You can only order up to ${mxq} of this item.` };
                } else {
                    cartItems[index].quantity = quantity;
                    if (cartItems[index].quantity <= 0) cartItems.splice(index, 1);
                    get().setCart(cartItems);
                    return { status: true, message: "Cart updated" };
                }
            } else if (quantity > 0) {
                if (mxq > 0 && (quantity > mxq)) {
                    return { status: false, message: "Maximum quantity exceeded", error: `You can only order up to ${mxq} of this item.` };
                } else {
                    cartItems.push({ pdt_id, variant_id, quantity });
                    get().setCart(cartItems);
                    return { status: true, message: "Cart updated" };
                }
            }
            // If none of the above conditions are met, return a default IResponse
            return { status: false, message: "Invalid cart update", error: "No valid cart update performed" };
        }
    }
}))



export default useCartStore